// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"49516cc3","221":"504469a4","270":"aceef018","326":"6d37be3c","345":"99657c23","413":"1b6af4b4","540":"149a290b"}[chunkId] + ".chunk.js";
};